import { _ } from "libs";

import React from "react";

function Loader({ text, loading = true, notext = false }: { text?: string; loading?: boolean; notext?: boolean }) {
	if (!loading) {
		return null;
	}

	return (
		<div className="loading">
			<div className="spinner" />
			{!notext ? <div className="label">{typeof text === "string" ? text : _("loader.defaultText")}</div> : null}
		</div>
	);
}

export default Loader;
